import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import type { PageProps } from "gatsby";

import { GatsbySeo } from "gatsby-plugin-next-seo";

import { BlockType, PageType } from "../../../types";

import Layout from "../../layouts/Layout";
import Block from "./Block";
import { ISalesChannel } from "../../../services/ecommerceApi/SalesChannel/types";
import LocationContext from "../../../context/LocationContext";
import FAQSchema from "./FAQSchema";

export const GATSBY_SITE_URL = process.env.GATSBY_SITE_URL || "";

const IndexPage = ({ pageContext, data, location }: PageProps<{
    page: Partial<PageType>;
    pageTemplate?: any;
    salesChannel: ISalesChannel;
}>) => {

    const { page, pageTemplate, salesChannel } = data;

    const { blocks, seo } = pageContext as any;

    const title = page?.title || seo?.title || salesChannel?.name;
    const description = page?.desc || seo?.description || salesChannel?.desc;
    const noIndex = salesChannel?.noIndex ? true : seo?.noIndex ? true : false;

    const origin = GATSBY_SITE_URL || location.origin;

    const canonical = seo?.pageUrl || `${origin}${page.slug}/` || undefined;

    const openGraphTitle = seo.title || page.title || salesChannel.name;
    const openGraphDescription = seo.description || page.desc || salesChannel.desc;
    const openGraphImage = origin + seo.imageFile?.publicURL || seo.imageUrl || page.imageUrl || origin + salesChannel.logoFile?.publicURL;

    return (
        <LocationContext.Provider value={{ location }} >
            <GatsbySeo
                title={title}
                description={description}
                canonical={canonical}
                noindex={noIndex}
                openGraph={{
                    type: "website",
                    url: canonical,
                    title: openGraphTitle,
                    description: openGraphDescription,
                    images: [
                        {
                            url: openGraphImage
                        }
                    ]
                }}
                metaTags={seo?.keywords ? [{
                    property: "keywords",
                    content: seo.keywords
                }] : []}
            />
            <Layout pageTemplate={pageTemplate}>
                {blocks.map((block: BlockType) => (
                    <Block
                        block={block}
                        key={block.id}
                        location={location}
                        pageTitle={title}
                        salesChannel={salesChannel}
                    />
                ))}

                <FAQSchema blocks={blocks} />

            </Layout>
        </LocationContext.Provider>
    );
};
export default IndexPage;

export const query = graphql`
    query ($template: String!, $pageId: String) {
        page(id: {eq: $pageId}){
            id
            slug
            title
            desc
            imageUrl{
                id
                url
                name
            }
        }
        pageTemplate(id: { eq: $template }) {
            id
            name
            header {
                menu
                menus {
                    id
                    name
                    displayName
                }
                logo
            }
            footer {
                menu
                menus {
                    id
                    name
                    displayName
                }
                logo
            }
        }
        salesChannel {
            id
            name
            email
            websiteTemplate
            logo
            logoFile{
                publicURL
            }
            phone
            address
            metadata
            type
            noIndex
        }
    }
`;
